<template id="userTemplate">
  <div class="component-container">
    <app-navigation></app-navigation>
    <div class="main-div" :class="formState.invalidShake ? '--invalid' : ''">
      <small class="--centered-block"
        >Select a User From the list to edit</small
      >
      <div class="form-group col-12 col-sm-12">
        <label class="pl-0 col-12 col-sm-12">All Users</label>
        <div class="mb-4 p-0 col-12 col-sm-12">
          <div class="p-0 col-12 col-sm-3">
            <label class="pl-0 col-12 col-sm-12">Email</label>
            <input
              class="form-control col-12 col-sm-12"
              type="text"
              maxlength="200"
              v-model="searchCriteria.email"
              placeholder="Search By Email"
              v-on:input="
                searchPage = 1;
                fetchAllUsers();
              "
            />
          </div>
          <div class="p-0 col-12 col-sm-3">
            <label class="pl-0 col-12 col-sm-12">Mobile</label>
            <input
              class="form-control col-12 col-sm-12"
              type="number"
              maxlength="25"
              v-model="searchCriteria.mobile"
              placeholder="Search By Mobile"
              v-on:input="
                searchPage = 1;
                fetchAllUsers();
              "
            />
          </div>
          <div class="p-0 col-12 col-sm-3">
            <label class="pl-0 col-12 col-sm-12">City</label>
            <b-form-select
              :disabled="formState.loading"
              class="modified-dropdown form-control col-12 col-sm-12"
              :options="dropDownPlaces"
              v-model="searchCriteria.placeId"
              v-on:input="
                searchPage = 1;
                fetchAllUsers();
              "
            ></b-form-select>
          </div>
        </div>
        <div class="user-row">
          <p class="user-heading">Name</p>
          <p class="user-heading">Email</p>
          <p class="user-heading">Mobile</p>
          <p class="user-heading">Address</p>
          <p class="user-heading">Discount</p>
          <p class="user-heading">City</p>
          <p class="user-heading">Existing Customer</p>
        </div>
        <div
          v-for="(user, index) in fetchedUsers"
          v-on:click="
            selectedUserData = { ...user };
            selectedUserId = user.id;
          "
          class="user-row"
          :key="index"
        >
          <p class="user-col">{{ user.name }}</p>
          <p class="user-col">{{ user.email }}</p>
          <p class="user-col">{{ user.mobile ? user.mobile : "Unkown" }}</p>
          <p class="user-col">{{ user.address ? user.address : "Unknown" }}</p>
          <p class="user-col">{{ user.discount ? user.discount : "None" }}</p>
          <p class="user-col">
            {{
              searchPlace(user.area_id)
                ? searchPlace(user.area_id).name
                : "Unknown"
            }}
          </p>
          <p class="user-col">{{ user.isPrev == true ? "Yes" : "No" }}</p>
        </div>
        <div
          style="justify-content: center"
          v-if="fetchedUsers.length < 20"
          class="alert alert-info w-100"
        >
          No more users
        </div>
        <!-- <button
          type="button"
          class="mb-2 btn btn-info col-12 col-sm-3"
          v-on:click="advancePageAndFetch(false)"
          v-if="
            (!isSearching() && searchCriteria.page > 1) ||
            (isSearching() && searchPage > 1)
          "
          :disabled="formState.loading"
        >
          Previous Page
        </button>
        <button
          type="button"
          class="mb-2 btn btn-info col-12 col-sm-3"
          v-on:click="advancePageAndFetch(true)"
          v-if="fetchedUsers.length >= 20"
          :disabled="formState.loading"
        >
          Next Page
        </button> -->

        <nav aria-label="...">
          <ul class="pagination">
            <li
              class="page-item"
              v-if="
              (!isSearching() && searchCriteria.page > 1) ||
                (isSearching() && searchPage > 1)
              "
              v-on:click="fixedPageAndFetch(1)"
            >
              <a class="page-link">First</a>
            </li>
            <li
              class="page-item"
              v-if="
                (!isSearching() && searchCriteria.page > 1) ||
                (isSearching() && searchPage > 1)
              "
            >
              <a
                class="page-link"
                tabindex="-1"
                v-on:click="advancePageAndFetch(false)"
                >Previous</a
              >
            </li>
            <li
              class="page-item"
              v-for="(pg, index) in searchPagesArr"
              :key="index"
              v-bind:class="{ active: pg === searchCriteria.page }"
              v-on:click="fixedPageAndFetch(pg)"
            >
              <a class="page-link" href="#">{{ pg }}<span class="sr-only" v-if="pg === searchCriteria.page">(current)</span></a>
            </li>
            <li class="page-item" v-if="fetchedUsers.length >= 20">
              <a class="page-link" v-on:click="advancePageAndFetch(true)"
                >Next</a
              >
            </li>
            <li
              class="page-item"
              v-if="count > 0"
              v-on:click="fixedPageAndFetch(count)"
            >
              <a class="page-link">Last</a>
            </li>
          </ul>
        </nav>
      </div>

      <!-- TEMP: Comment the partially "Export" feature -->
      <!-- <div class="col-12 col-sm-4">
        <button
          type="button"
          class="mb-2 btn btn-success col-12 col-sm-12"
          v-on:click="exportUsers"
          v-if="fetchedUsers.length>0"
          :disabled="formState.loading"
        >Export Shown Users</button>
      </div> -->
      <!-- v-on:click="searchCriteria.page=searchCriteria.page==null?searchCriteria.page++:2;fetchAllUsers()" -->
      <!--
        <b class="w-100">Please correct the following error(s):</b>
        <ul>
          <li v-for="(error,index) in errors" :key="index">{{ error }}</li>
        </ul>
      </div>-->

      <div id="slectedUserForm" class="user-form">
        <fieldset
          :disabled="formState.loading"
          class="col-12 col-sm-12"
          v-if="selectedUserData"
        >
          <div class="row">
            <p v-on:click="selectedUserId = null" class="close-div-tag">
              Close User
            </p>
          </div>
          <legend>All User's Data</legend>
          <div v-if="errors.length">
            <b class="w-100">Please correct the following error(s):</b>
            <ul>
              <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
            </ul>
          </div>
          <div class="row">
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-12">Name</label>
              <input
                class="form-control col-12 col-sm-12"
                v-model="selectedUserData.name"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-12">Email</label>
              <input
                disabled
                class="form-control col-12 col-sm-12"
                v-model="selectedUserData.email"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-12">Mobile</label>
              <input
                class="form-control col-12 col-sm-12"
                type="tel"
                v-model="selectedUserData.mobile"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-12">Address</label>
              <input
                class="form-control col-12 col-sm-12"
                v-model="selectedUserData.address"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-12">Discount</label>
              <input
                type="number"
                min="0"
                max="100"
                class="form-control col-12 col-sm-12"
                v-model="selectedUserData.discount"
              />
            </div>
            <div class="form-group col-12 col-sm-6">
              <label class="pl-0 col-12 col-sm-12">City</label>
              <b-form-select
                :disabled="formState.loading"
                class="modified-dropdown form-control col-12 col-sm-12"
                :options="dropDownPlaces"
                v-model="selectedUserData.area_id"
              ></b-form-select>
            </div>
            <div
              class="form-group col-12 col-sm-6"
              v-if="!selectedUserData.social_id"
            >
              <label class="pl-0 col-12 col-sm-12">Existing User</label>
              <p class="col-12 col-sm-6">
                {{ selectedUserData.isPrev == true ? "Yes" : "No" }}
              </p>
              <button
                type="button"
                class="mb-2 btn col-12 col-sm-6"
                :class="
                  selectedUserData.isPrev == true ? 'btn-danger' : 'btn-info'
                "
                v-on:click="
                  selectedUserData.isPrev = !(selectedUserData.isPrev == true)
                "
                :disabled="formState.loading"
              >
                {{
                  selectedUserData.isPrev == true
                    ? "Make Non-Existing"
                    : "Make Existing"
                }}
              </button>
            </div>
            <div
              class="form-group col-12 col-sm-6"
              v-if="!selectedUserData.social_id"
            >
              <label class="pl-0 col-12 col-sm-12">Activated User</label>
              <p class="col-12 col-sm-6">
                {{ selectedUserData.active == true ? "Yes" : "No" }}
              </p>
              <button
                type="button"
                class="mb-2 btn col-12 col-sm-6"
                :class="
                  selectedUserData.active == true ? 'btn-danger' : 'btn-info'
                "
                v-on:click="
                  selectedUserData.active = !(selectedUserData.active == true)
                "
                :disabled="formState.loading"
              >
                {{
                  selectedUserData.active == true ? "Deactivate" : "Activate"
                }}
              </button>
            </div>
            <div class="form-group col-12 col-sm-12 alert alert-info" v-else>
              Because This user signed up using social media, you may not
              deactivate this user or make this user existing.
            </div>
          </div>
          <hr class="separator" v-if="selectedUserData" />
          <div class="form-group col-12 col-sm-12">
            <div
              v-if="
                selectedUserData.orderData && selectedUserData.orderData.length
              "
              class="alert alert-danger col-12 col-sm-12"
            >
              This Users has orders. If you delete this user, his orders will
              not be visible ever again.
            </div>
            <button
              type="button"
              class="mb-2 btn col-12 col-sm-4 btn-info"
              v-on:click="commitUserChanges"
              :disabled="formState.loading"
            >
              Confirm Changes to User Data
            </button>
            <button
              type="button"
              class="mb-2 btn col-12 col-sm-4 btn-danger"
              v-on:click="deleteUser"
              :disabled="formState.loading"
            >
              Delete User
            </button>
          </div>
        </fieldset>

        <hr
          class="separator --black-background"
          v-if="selectedUserData && selectedUserData.measurementData"
        />

        <fieldset
          :disabled="formState.loading"
          class="col-12 col-sm-12"
          v-if="selectedUserData && selectedUserData.measurementData"
        >
          <legend>User's Measurement Profiles</legend>
          <div
            class="user-row"
            v-for="(measurement, index) in selectedUserData.measurementData"
            v-on:click="
              selectedMeasurementData = measurement;
              selectedMeasurementId = selectedMeasurementData.id;
              checkForm();
            "
            :disabled="selectedMeasurementId != null"
            :key="index"
          >
            <p>
              Measurement Name : {{ measurement.name }}
              <span
                v-if="measurement.default_profile == true"
                class="default-tag"
                >Default</span
              >
            </p>
            <p
              v-on:click="deselectMeasurement"
              v-if="measurement.id == selectedMeasurementId"
              class="close-div-tag"
            >
              Close Measurement
            </p>
            <div
              class="user-row__measurement"
              v-if="measurement.id == selectedMeasurementId"
            >
              <div class="row">
                <div
                  v-if="
                    measurementErrors.length &&
                    formState.attempted &&
                    !formState.loading
                  "
                  class="alert alert-danger col-12 col-sm-12"
                >
                  <span
                    style="width: 100%"
                    v-for="(
                      measurementError, indexxOfError
                    ) in measurementErrors"
                    :key="indexxOfError"
                    >{{ measurementError }}</span
                  >
                </div>
                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12">
                    Name
                    <small>Required</small>
                  </label>
                  <input
                    class="form-control col-12 col-sm-12"
                    v-on:input="checkForm"
                    v-model="measurement.name"
                  />
                </div>
                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12">Default Profile</label>
                  <p class="col-12 col-sm-6">
                    {{
                      measurement.default_profile == true
                        ? "Yes, Default"
                        : "Not Default"
                    }}
                  </p>

                  <button
                    v-if="measurement.default_profile != true"
                    type="button"
                    class="mb-2 btn col-12 col-sm-6 btn-info"
                    v-on:click="
                      measurement.default_profile = !(
                        measurement.default_profile == true
                      );
                      makeOtherMeasurementProfilesNonDefault(measurement.id);
                    "
                    :disabled="formState.loading"
                  >
                    Make Default
                  </button>
                  <small
                    v-if="measurement.default_profile != true"
                    class="--centered-block col-12 col-sm-12"
                  >
                    Only
                    <b>ONE</b> profile can be the default at a time. The
                    currently default profile will be redeemed non-default.
                  </small>
                </div>
                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12">Length</label>
                  <input
                    type="number"
                    min="50"
                    max="185"
                    class="form-control col-12 col-sm-12"
                    v-on:input="checkForm"
                    v-model="measurement.value_1"
                  />
                </div>
                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12">Shoulder</label>
                  <input
                    type="number"
                    min="22"
                    max="60"
                    class="form-control col-12 col-sm-12"
                    v-on:input="checkForm"
                    v-model="measurement.value_2"
                  />
                </div>
                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12">Waist</label>
                  <input
                    type="number"
                    min="30"
                    max="94"
                    class="form-control col-12 col-sm-12"
                    v-on:input="checkForm"
                    v-model="measurement.value_3"
                  />
                </div>
                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12">Sleeve's Length</label>
                  <input
                    type="number"
                    min="24"
                    max="75"
                    class="form-control col-12 col-sm-12"
                    v-on:input="checkForm"
                    v-model="measurement.value_4"
                  />
                </div>
                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12"
                    >Cuff’s circumference</label
                  >
                  <input
                    type="number"
                    min="16"
                    max="33"
                    class="form-control col-12 col-sm-12"
                    v-on:input="checkForm"
                    v-model="measurement.value_5"
                  />
                </div>
                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12">Sleeve’s Width</label>
                  <input
                    type="number"
                    min="8"
                    max="23"
                    class="form-control col-12 col-sm-12"
                    v-on:input="checkForm"
                    v-model="measurement.value_6"
                  />
                </div>
                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12"
                    >Thoob’s neck circumference</label
                  >
                  <input
                    type="number"
                    min="28"
                    max="53"
                    class="form-control col-12 col-sm-12"
                    v-on:input="checkForm"
                    v-model="measurement.value_7"
                  />
                </div>
                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12"
                    >Thoob’s Full chest</label
                  >
                  <input
                    type="number"
                    min="35"
                    max="95"
                    class="form-control col-12 col-sm-12"
                    v-on:input="checkForm"
                    v-model="measurement.value_8"
                  />
                </div>
                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12"
                    >Thoob’s F.chest</label
                  >
                  <input
                    type="number"
                    min="40"
                    max="95"
                    class="form-control col-12 col-sm-12"
                    v-on:input="checkForm"
                    v-model="measurement.value_9"
                  />
                </div>
                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12"
                    >Thoob’s hips</label
                  >
                  <input
                    type="number"
                    min="36"
                    max="100"
                    class="form-control col-12 col-sm-12"
                    v-on:input="checkForm"
                    v-model="measurement.value_10"
                  />
                </div>
                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12"
                    >Thoob’s armhole</label
                  >
                  <input
                    type="number"
                    min="10"
                    max="30"
                    class="form-control col-12 col-sm-12"
                    v-on:input="checkForm"
                    v-model="measurement.value_11"
                  />
                </div>
                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12"
                    >Thoob’s bottom length</label
                  >
                  <input
                    type="number"
                    min="40"
                    max="10"
                    class="form-control col-12 col-sm-12"
                    v-on:input="checkForm"
                    v-model="measurement.value_12"
                  />
                </div>
              </div>

              <hr class="separator" v-if="selectedUserData" />
              <div class="form-group col-12 col-sm-12">
                <button
                  type="button"
                  class="mb-2 btn col-12 col-sm-4 btn-info"
                  v-on:click="commitMeasurementChanges"
                  :disabled="formState.loading"
                >
                  Confirm Changes to User's Measurements
                </button>
                <button
                  type="button"
                  class="mb-2 btn col-12 col-sm-4 btn-danger"
                  :disabled="formState.loading"
                  v-on:click="deleteMeasurement"
                >
                  Delete Measurement
                </button>
              </div>
            </div>
          </div>
        </fieldset>
        <hr class="separator --black" v-if="selectedUserData" />
        <div
          class="form-group col-12 col-sm-12"
          v-if="selectedUserId && !newMeasurementProfile"
        >
          <button
            type="button"
            class="mb-2 btn col-12 col-sm-4 btn-info"
            v-on:click="addNewMeasurement"
            :disabled="formState.loading"
          >
            Add a new User Measurement Profile
          </button>
        </div>

        <fieldset
          :disabled="formState.loading"
          class="col-12 col-sm-12"
          :class="formState.invalidShake ? '--invalid' : ''"
          v-if="newMeasurementProfile"
        >
          <legend>Add a New Measurement Profile</legend>
          <div class="user-row">
            <p v-on:click="newMeasurementProfile = null" class="close-div-tag">
              Cancel
            </p>
            <div class="user-row__measurement">
              <div class="row">
                <div class="form-group col-12 col-sm-6">
                  <div
                    v-if="
                      newMeasurementErrors.length &&
                      formState.attempted &&
                      !formState.loading
                    "
                    class="alert alert-danger col-12 col-sm-12"
                  >
                    <span
                      style="width: 100%"
                      v-for="(
                        newMeasurementError, indexOfError
                      ) in newMeasurementErrors"
                      :key="indexOfError"
                      >{{ newMeasurementError }}</span
                    >
                  </div>

                  <label class="pl-0 col-12 col-sm-12">
                    Name
                    <small>Required</small>
                  </label>
                  <input
                    v-on:input="checkForm"
                    class="form-control col-12 col-sm-12"
                    v-model="newMeasurementProfile.name"
                  />
                </div>
                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12">Default Profile</label>
                  <p class="col-12 col-sm-6">
                    {{
                      newMeasurementProfile.defaultProfile == true
                        ? "Yes, Default"
                        : "Not Default"
                    }}
                  </p>

                  <button
                    type="button"
                    class="mb-2 btn col-12 col-sm-6"
                    :class="
                      newMeasurementProfile.defaultProfile == true
                        ? 'btn-danger'
                        : 'btn-info'
                    "
                    v-on:click="
                      newMeasurementProfile.defaultProfile = !(
                        newMeasurementProfile.defaultProfile == true
                      )
                    "
                    :disabled="formState.loading"
                  >
                    {{
                      newMeasurementProfile.defaultProfile == true
                        ? "Make Non-Default"
                        : "Make Default"
                    }}
                  </button>
                  <small
                    v-if="newMeasurementProfile.defaultProfile != true"
                    class="--centered-block col-12 col-sm-12"
                  >
                    Only
                    <b>ONE</b> profile can be the default at a time. The
                    currently default profile will be redeemed non-default.
                  </small>
                </div>

                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12">Length</label>
                  <input
                    type="number"
                    min="50"
                    max="185"
                    class="form-control col-12 col-sm-12"
                    v-on:input="checkForm"
                    v-model="newMeasurementProfile.value1"
                  />
                </div>
                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12">Shoulder</label>
                  <input
                    type="number"
                    min="22"
                    max="60"
                    class="form-control col-12 col-sm-12"
                    v-on:input="checkForm"
                    v-model="newMeasurementProfile.value2"
                  />
                </div>

                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12">Waist</label>
                  <input
                    type="number"
                    min="30"
                    max="94"
                    class="form-control col-12 col-sm-12"
                    v-on:input="checkForm"
                    v-model="newMeasurementProfile.value3"
                  />
                </div>
                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12">Sleeve's Length</label>
                  <input
                    type="number"
                    min="24"
                    max="75"
                    class="form-control col-12 col-sm-12"
                    v-on:input="checkForm"
                    v-model="newMeasurementProfile.value4"
                  />
                </div>
                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12"
                    >Cuff’s circumference</label
                  >
                  <input
                    type="number"
                    min="16"
                    max="33"
                    class="form-control col-12 col-sm-12"
                    v-on:input="checkForm"
                    v-model="newMeasurementProfile.value5"
                  />
                </div>
                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12">Sleeve’s Width</label>
                  <input
                    type="number"
                    min="8"
                    max="23"
                    class="form-control col-12 col-sm-12"
                    v-on:input="checkForm"
                    v-model="newMeasurementProfile.value6"
                  />
                </div>
                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12"
                    >Thoob’s neck circumference</label
                  >
                  <input
                    type="number"
                    min="28"
                    max="53"
                    class="form-control col-12 col-sm-12"
                    v-on:input="checkForm"
                    v-model="newMeasurementProfile.value7"
                  />
                </div>
                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12"
                    >Thoob’s Full chest</label
                  >
                  <input
                    type="number"
                    min="35"
                    max="95"
                    class="form-control col-12 col-sm-12"
                    v-on:input="checkForm"
                    v-model="newMeasurementProfile.value8"
                  />
                </div>
                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12"
                    >Thoob’s F.chest</label
                  >
                  <input
                    type="number"
                    min="40"
                    max="95"
                    class="form-control col-12 col-sm-12"
                    v-on:input="checkForm"
                    v-model="newMeasurementProfile.value9"
                  />
                </div>
                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12"
                    >Thoob’s hips</label
                  >
                  <input
                    type="number"
                    min="36"
                    max="100"
                    class="form-control col-12 col-sm-12"
                    v-on:input="checkForm"
                    v-model="newMeasurementProfile.value10"
                  />
                </div>
                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12"
                    >Thoob’s armhole</label
                  >
                  <input
                    type="number"
                    min="10"
                    max="30"
                    class="form-control col-12 col-sm-12"
                    v-on:input="checkForm"
                    v-model="newMeasurementProfile.value11"
                  />
                </div>
                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12"
                    >Thoob’s bottom length</label
                  >
                  <input
                    type="number"
                    min="40"
                    max="100"
                    class="form-control col-12 col-sm-12"
                    v-on:input="checkForm"
                    v-model="newMeasurementProfile.value12"
                  />
                </div>
              </div>
              <hr class="separator" />
              <div class="form-group col-12 col-sm-12">
                <button
                  type="button"
                  class="mb-2 btn col-12 col-sm-4 btn-info"
                  v-on:click="addNewMeasurementAPI"
                  :disabled="formState.loading"
                >
                  Add New Measurement
                </button>
              </div>
            </div>
          </div>
        </fieldset>

        <hr
          class="separator --black-background"
          v-if="selectedUserData && selectedUserData.orderData"
        />

        <fieldset
          :disabled="formState.loading"
          class="col-12 col-sm-12"
          v-if="selectedUserData && selectedUserData.orderData"
        >
          <legend>User's Orders</legend>
          <h6 v-if="selectedUserId">
            <router-link :to="{ path: '/users/' + selectedUserId + '/orders' }"
              >To edit user's Orders in detail, Click Here.</router-link
            >
          </h6>

          <div
            class="user-row"
            v-for="(order, index) in selectedUserData.orderData"
            v-on:click="
              selectedOrderData = order;
              selectedOrderId = selectedOrderData.id;
            "
            :disabled="selectedOrderId != null"
            :key="index"
          >
            <div class="--height-max- w-100">
              <p>Order ID : {{ order.id }}</p>
              <p
                v-on:click="deselectOrder"
                v-if="order.id == selectedOrderId"
                class="close-div-tag"
              >
                Close Order
              </p>
            </div>
            <div class="user-row__order" v-if="order.id == selectedOrderId">
              <div class="w-100">
                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12">ID</label>
                  <input
                    class="form-control col-12 col-sm-12"
                    disabled
                    v-model="order.id"
                  />
                </div>
                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12">Order Status</label>
                  <b-form-select
                    :disabled="formState.loading"
                    class="modified-dropdown form-control col-12 col-sm-12"
                    :options="orderStatuses"
                    v-model="order.status"
                    v-on:change="changeOrderStatus"
                  ></b-form-select>
                </div>
                <div class="form-group col-12 col-sm-6">
                  <label class="pl-0 col-12 col-sm-12">Delivery Type</label>
                  <b-form-select
                    :disabled="formState.loading"
                    class="modified-dropdown form-control col-12 col-sm-12"
                    :options="deliveryTypes"
                    v-model="order.delivery_type"
                    v-on:change="changeOrderDeliveryType"
                  ></b-form-select>
                </div>
              </div>

              <hr class="separator" v-if="selectedUserData" />
              <div class="form-group col-12 col-sm-12">
                <!-- <button
                  type="button"
                  class="mb-2 btn col-12 col-sm-4 btn-info"
                  v-on:click="changeOrderStatus"
                  :disabled="formState.loading"
                >Confirm Changes to User's Order</button>-->
                <button
                  type="button"
                  class="mb-2 btn col-12 col-sm-4 btn-danger"
                  :disabled="formState.loading"
                  v-on:click="deleteOrder"
                >
                  Delete Order
                </button>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
</template>



<!-- user Template -->




<style lang='scss' scoped>
@import "../../node_modules/bootstrap/scss/bootstrap.scss";
.modified-dropdown {
  -webkit-appearance: menulist;
  background: none;
}
.component-container {
  min-height: 100%;
  display: flex;
}
.main-div {
  padding: 50px;
  width: 80%;
  ::-webkit-scrollbar {
    width: 0px;
    height: 5px;
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: darkgray;
  }
  div {
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
    text-align: left;
    justify-content: space-between;
  }
  .--height-max-content {
    height: max-content;
  }
  button {
    margin: 0 auto;
    padding: 10px 30px;
    font-size: 16px;
  }
  .separator {
    display: block;
    width: 100%;
    clear: both;
  }
  .--black-background {
    background-color: black;
  }

  .--centered-block {
    margin: 0 auto;
  }
  .default-tag {
    background-color: #17a2b8;
    border-style: solid;
    border-color: transparent;
    border-radius: 5px;
    font-size: 0.8em;
    padding: 0 5px;
    color: white;
  }

  .close-div-tag {
    background-color: #db0a5b;
    border-style: solid;
    border-color: transparent;
    border-radius: 5px;
    font-size: 0.8em;
    padding: 0 5px;
    color: white;
    cursor: pointer;
  }

  .user-row {
    width: 100%;
    padding: 5px;
    // overflow-x: scroll;
    height: auto;
    display: flex;
    border-radius: 5px;
    border-style: solid;
    border-color: transparent;
    background-color: #eeeeee;
    margin-bottom: 5px;
    cursor: pointer;
    &__measurement {
      cursor: default;
      padding-bottom: 10px !important;
    }
    &__order {
      cursor: default;
      padding-bottom: 10px !important;
      width: 100%;
    }
  }

  .user-heading {
    text-align: center;
    width: 14%;
    font-weight: bold;
    margin-bottom: 0;
  }
  .user-col {
    text-align: center;
    width: 14%;
    overflow-x: scroll;
    margin-bottom: 0;
  }
}
//  0.82s
.--invalid {
  animation: shake 0.82s infinite cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>

<script>
import axios from "axios";
/* eslint-disable no-unused-vars */
import VueAxios from "vue-axios";
import { constants } from "crypto";
import { setTimeout } from "timers";
/* eslint-enable no-unused-vars*/
import { getCookie } from "../cookie.js";
import { herokuUrl } from "../apiConfig";
import Navigation from "../components/Navigation.vue";
import { isNumber } from "util";
import logOut from "../scripts/utils";

export default {
  name: "usersCRUD",
  data() {
    return {
      searchPage: 1,
      searchPagesArr: [1],
      count: 0,
      searchCriteria: { page: 1, email: null, mobile: null, placeId: null }, // We search All users Depending on this.
      fetchedUsers: [], // fetched Users (page dependant).
      searchedUsers: [], // Call API to search for users.
      selectedUserId: null, // Specifies The Id of the selected user in the database
      selectedUserData: null, // Data is fetched from the backend using selectedUserId
      selectedMeasurementId: null, // Specifies The Id of the selected measurement in the database
      selectedMeasurementData: null, // Data is fetched from the backend using selectedUserId
      newMeasurementProfile: null, // New Measurement Profile null until a new one is to be added.
      selectedOrderId: null, // Specifies The Id of the selected order in the database
      selectedOrderData: null, // Data is fetched from the backend using selectedUserId
      places: [], // Data about all places fetched from the API
      dropDownPlaces: [{ value: null, text: "Please Select a city" }], // Only cities are shown
      orderStatuses: [
        { value: "new", text: "New - جديد" },
        { value: "production", text: "Production - فى مرحلة الإنتاج" },
        { value: "delivered", text: "Delivered - تم التوصيل" },
        { value: "cancelled", text: "Cancelled - تم الإلغاء" },
        { value: "pickable", text: "Pickable - جاهز للمعاينة" },
        {
          value: "pending_payment",
          text: "Pending Payment - فى إنتظار الحوالة",
        },
      ],
      deliveryTypes: [
        { value: "home", text: "Home" },
        { value: "branch", text: "Branch" },
      ],
      errors: [], // Form's errors
      newMeasurementErrors: [], // Form's errors
      measurementErrors: [],
      formState: {
        loading: false,
        attempted: false,
        invalidShake: false,
      }, // Object Determining the Form's state
    };
  },
  watch: {
    // Computes the Filtered Array out of users fetched from backend.
    searchCriteria: function () {
      this.filteredUsers = this.users.filter((str) => {
        return this.searchCriteria == ""
          ? true
          : str.text.toLowerCase().includes(this.searchCriteria.toLowerCase());
      });
    },
    // When selectedUserId is changed, the user's Data is fetched from the backend, If null is selected, the form is reset.
    selectedUserId: function () {
      if (this.selectedUserId) {
        this.fetchAllUserMeasurements(this.selectedUserId);
        this.fetchAllUserOrders(this.selectedUserId);
        this.smoothScroll("slectedUserForm");
      } else {
        this.partiallyResetForm();
      }
    },
    "selectedUserData.name": function () {
      this.checkForm();
    },
    "selectedUserData.email": function () {
      this.checkForm();
    },
    "selectedUserData.mobile": function () {
      this.checkForm();
    },
    "selectedUserData.area_id": function () {
      this.checkForm();
    },
    "selectedUserData.discount": function () {
      this.checkForm();
    },
  },
  mounted() {
    this.fetchAllPlaces();
    this.fetchAllUsers();
  },
  methods: {
    isSearching() {
      return !(
        (this.searchCriteria.email == "" ||
          this.searchCriteria.email == null) &&
        (this.searchCriteria.mobile == "" ||
          this.searchCriteria.mobile == null) &&
        this.searchCriteria.placeId == null
      );
    },
    advancePageAndFetch: function (increment) {
      if (increment) {
        if (this.isSearching()) {
          this.searchPage++;
          this.searchPagesArr = this.searchPagesArr.sort(function(a, b){return a-b});
        } else {
          this.searchCriteria.page++;
          if (!this.searchPagesArr.includes(this.searchCriteria.page)) {
            this.searchPagesArr.push(this.searchCriteria.page);
          }
          const array = this.searchPagesArr;
          console.log(array);
          if (array.length > 4) {
            this.searchPagesArr.splice(0, 1);
          }
        }
        this.searchPagesArr = this.searchPagesArr.sort(function(a, b){return a-b});
      } else {
        if (this.isSearching()) {
          this.searchPage--;
        } else {
          const array = this.searchPagesArr;
          console.log(array);
          if (array.length > 4) {
            if (array.length < array[array.length - 1]) {
              this.searchPagesArr.splice(array.length - 1, 1);
            } else {
              const index = array.indexOf(this.searchCriteria.page);
              if (index > -1) {
                this.searchPagesArr.splice(index, 1);
              }
            }
          }

          this.searchCriteria.page--;
          if (!this.searchPagesArr.includes(this.searchCriteria.page)) {
            this.searchPagesArr.unshift(this.searchCriteria.page);
          }
        this.searchPagesArr = this.searchPagesArr.sort(function(a, b){return a-b});
        }
      }
      this.fetchAllUsers();
    },
    fixedPageAndFetch: function (number) {
      if (this.isSearching()) {
        this.searchPage = number;
      } else {
        this.searchCriteria.page = number;
        if (!this.searchPagesArr.includes(this.searchCriteria.page)) {
          this.searchPagesArr.push(this.searchCriteria.page);
        }
        const array = this.searchPagesArr;
        console.log(array);
        if (array.length > 4) {
          this.searchPagesArr.splice(0, 1);
        }
        this.searchPagesArr = this.searchPagesArr.sort();
      }
      this.fetchAllUsers();
    },
    exportUsers: function () {
      let fileString =
        "<style>td{padding: 10px;border-bottom: grey;border-bottom-style: solid;}</style><table>";
      fileString +=
        "<tr><td>Name</td><td>Email</td><td>Mobile</td><td>Address</td><td>Discount</td><td>City</td><td>Existing Customer</td></tr>";

      this.fetchedUsers.forEach((user) => {
        let mobile = user.mobile ? user.mobile : "Unkown";
        if (user.mobile) {
          let mobileSplit = String(user.mobile);
          let newMobile = "";
          let i, j;
          for (i = 0, j = 3; i + j < mobileSplit.length; i += j) {
            j += j % 2 == 0 ? -1 : 1;
            newMobile += mobileSplit.slice(i, i + j) + " ";
          }
          newMobile += mobileSplit.slice(i, mobileSplit.length);
          // eslint-disable-next-line
          console.log(newMobile);
          mobile = newMobile;
        }
        let address = user.address ? user.address : "Unknown";
        let discount = user.discount ? user.discount : "None";
        let area = this.searchPlace(user.area_id)
          ? this.searchPlace(user.area_id).name
          : "Unknown";
        let isPrev = user.isPrev == true ? "Yes" : "No";

        fileString += "<tr>";

        fileString += "<td>" + user.name + "</td>";
        fileString += "<td>" + user.email + "</td>";
        fileString += "<td>" + mobile + "</td>";
        fileString += "<td>" + address + "</td>";
        fileString += "<td>" + discount + "</td>";
        fileString += "<td>" + area + "</td>";
        fileString += "<td>" + isPrev + "</td>";

        fileString += "</tr>";
      });
      fileString += "</table>";

      let element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(fileString)
      );
      element.setAttribute("download", "Users Export.html");
      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },
    // Partially resets the form
    partiallyResetForm: function () {
      // this.cancelNewUser();
      this.fetchAllUsers();
      this.selectedUserData = null;
      this.selectedUserId = null;
      this.errors = [];
      this.measurementErrors = [];
      this.newMeasurementErrors = [];
      this.formState = {
        loading: false,
        attempted: false,
        invalidShake: false,
      };
    },
    cancelNewMeasurement() {
      this.newMeasurementProfile = null;
    },
    addNewMeasurement() {
      this.newMeasurementProfile = {
        name: null,
        value1: null,
        value2: null,
        value3: null,
        value4: null,
        value5: null,
        value6: null,
        value7: null,
        value8: null,
        value9: null,
        value10: null,
        value11: null,
        value12: null,
        defaultProfile: false,
        userId: this.selectedUserId,
      };
      this.checkForm();
    },
    addNewMeasurementAPI() {
      this.formState.attempted = true;
      if (
        !this.newMeasurementErrors.length
        // (
        //   this.newMeasurementProfile.name == "" ||
        //   this.newMeasurementProfile.name == null
        // )
      ) {
        if (
          confirm("Please confirm you want to add the new measurement data")
        ) {
          this.formState.loading = true;
          let defaultMeasurementExists = false;
          this.selectedUserData.measurementData.forEach((measure) => {
            if (measure.default_profile == true)
              defaultMeasurementExists = true;
          });
          return axios
            .post(
              `${herokuUrl}/dashboard/addnewMeasurementprofile`,
              {
                ...this.newMeasurementProfile,
                defaultProfile: defaultMeasurementExists
                  ? this.newMeasurementProfile.defaultProfile
                  : true,
              },
              {
                headers: {
                  Authorization: getCookie("user"),
                },
              }
            )
            .then(() => {
              alert("measurement was Added successfully");
              // this.partiallyResetForm();
              this.newMeasurementProfile = null;
              this.errors = [];
              this.measurementErrors = [];
              this.newMeasurementErrors = [];
              this.formState = {
                loading: false,
                attempted: false,
                invalidShake: false,
              };
              this.fetchAllUserMeasurements(this.selectedUserId);
            })
            .catch((err) => {
              if (err.response.status == 401) {
                logOut();
              } else {
                this.formState.loading = false;
                alert(
                  "There was a problem adding the new measurement " +
                    err.response.data.message
                );
              }
            });
        }
      } else {
        this.shakeForm();
      }
    },
    smoothScroll(elemId) {
      document.getElementById(elemId).scrollIntoView({
        block: "start",
        inline: "nearest",
        behavior: "smooth",
      });
    },
    makeOtherMeasurementProfilesNonDefault(measurementId) {
      this.selectedUserData.measurementData.forEach((measure) => {
        if (measure.default_profile == true && measure.id != measurementId)
          measure.default_profile = false;
      });
    },
    deselectMeasurement(e) {
      e.stopPropagation();
      this.selectedMeasurementData = null;
      this.selectedMeasurementId = null;
    },
    deselectOrder(e) {
      e.stopPropagation();
      this.selectedOrderData = null;
      this.selectedOrderId = null;
    },
    checkForm: function () {
      this.errors = [];
      this.measurementErrors = [];
      this.newMeasurementErrors = [];
      if (this.selectedUserId) {
        if (!this.selectedUserData.name)
          this.errors.push("User's name is required");
        if (!this.selectedUserData.email)
          this.errors.push("User's email is required");
        if (!this.selectedUserData.mobile)
          this.errors.push("User's mobile is required");
        var isNum = /^[\d +]+$/.test(this.selectedUserData.mobile);
        if (
          this.selectedUserData.mobile &&
          (this.selectedUserData.mobile.length < 8 ||
            this.selectedUserData.mobile.length > 20 ||
            isNum !== true)
        )
          this.errors.push("User's mobile should be between 8 and 15 digits");
        if (this.selectedUserData.area_id == null)
          this.errors.push("User's city is required");
        if (
          this.selectedUserData.discount &&
          (this.selectedUserData.discount < 0 ||
            this.selectedUserData.discount > 100)
        )
          this.errors.push("Discount between 0 and 100");
        if (this.newMeasurementProfile) {
          if (
            this.newMeasurementProfile.name == "" ||
            this.newMeasurementProfile.name == null
          ) {
            this.newMeasurementErrors.push("Name is required");
          }
          if (
            (!(
              this.newMeasurementProfile.value1 == "" ||
              this.newMeasurementProfile.value1 == null
            ) &&
              this.newMeasurementProfile.value1 < 50) ||
            this.newMeasurementProfile.value1 > 185
          ) {
            this.newMeasurementErrors.push("Length must be between 50 and 185");
          }
          if (
            (!(
              this.newMeasurementProfile.value2 == "" ||
              this.newMeasurementProfile.value2 == null
            ) &&
              this.newMeasurementProfile.value2 < 22) ||
            this.newMeasurementProfile.value2 > 60
          ) {
            this.newMeasurementErrors.push(
              "Shoulder must be between 22 and  60"
            );
          }
          if (
            (!(
              this.newMeasurementProfile.value3 == "" ||
              this.newMeasurementProfile.value3 == null
            ) &&
              this.newMeasurementProfile.value3 < 30) ||
            this.newMeasurementProfile.value3 > 94
          ) {
            this.newMeasurementErrors.push("Waist must be between 30 and  94");
          }
          if (
            (!(
              this.newMeasurementProfile.value4 == "" ||
              this.newMeasurementProfile.value4 == null
            ) &&
              this.newMeasurementProfile.value4 < 24) ||
            this.newMeasurementProfile.value4 > 75
          ) {
            this.newMeasurementErrors.push(
              "Sleeve's Length must be between 24 and  75"
            );
          }
          if (
            (!(
              this.newMeasurementProfile.value5 == "" ||
              this.newMeasurementProfile.value5 == null
            ) &&
              this.newMeasurementProfile.value5 < 16) ||
            this.newMeasurementProfile.value5 > 33
          ) {
            this.newMeasurementErrors.push(
              "Cuff’s circumference must be between 16 and  33"
            );
          }
          if (
            (!(
              this.newMeasurementProfile.value6 == "" ||
              this.newMeasurementProfile.value6 == null
            ) &&
              this.newMeasurementProfile.value6 < 8) ||
            this.newMeasurementProfile.value6 > 23
          ) {
            this.newMeasurementErrors.push(
              "Sleeve’s Width must be between 8 and 23"
            );
          }
          if (
            (!(
              this.newMeasurementProfile.value7 == "" ||
              this.newMeasurementProfile.value7 == null
            ) &&
              this.newMeasurementProfile.value7 < 28) ||
            this.newMeasurementProfile.value7 > 53
          ) {
            this.newMeasurementErrors.push(
              "Thoob’s neck circumference must be between 28 and  53"
            );
          }
          if (
            (!(
              this.newMeasurementProfile.value8 == "" ||
              this.newMeasurementProfile.value8 == null
            ) &&
              this.newMeasurementProfile.value8 < 35) ||
            this.newMeasurementProfile.value8 > 95
          ) {
            this.newMeasurementErrors.push(
              "Thoob’s neck circumference must be between 35 and  95"
            );
          }
          if (
            (!(
              this.newMeasurementProfile.value9 == "" ||
              this.newMeasurementProfile.value9 == null
            ) &&
              this.newMeasurementProfile.value9 < 40) ||
            this.newMeasurementProfile.value9 > 95
          ) {
            this.newMeasurementErrors.push(
              "Thoob’s F.chest must be between 40 and  95"
            );
          }
          if (
            (!(
              this.newMeasurementProfile.value10 == "" ||
              this.newMeasurementProfile.value10 == null
            ) &&
              this.newMeasurementProfile.value10 < 36) ||
            this.newMeasurementProfile.value10 > 100
          ) {
            this.newMeasurementErrors.push(
              "Thoob’s hips must be between 36 and  100"
            );
          }
          if (
            (!(
              this.newMeasurementProfile.value11 == "" ||
              this.newMeasurementProfile.value11 == null
            ) &&
              this.newMeasurementProfile.value11 < 10) ||
            this.newMeasurementProfile.value11 > 30
          ) {
            this.newMeasurementErrors.push(
              "Thoob’s armhole must be between 10 and  30"
            );
          }
          if (
            (!(
              this.newMeasurementProfile.value12 == "" ||
              this.newMeasurementProfile.value12 == null
            ) &&
              this.newMeasurementProfile.value12 < 40) ||
            this.newMeasurementProfile.value12 > 100
          ) {
            this.newMeasurementErrors.push(
              "Thoob’s bottom length must be between 40 and  100"
            );
          }
        }
        if (this.selectedMeasurementData) {
          if (
            this.selectedMeasurementData.name == "" ||
            this.selectedMeasurementData.name == null
          ) {
            this.measurementErrors.push("Name is required");
          }
          console.log(this.selectedMeasurementData.value_1);
          if (
            (!(
              this.selectedMeasurementData.value_1 == "" ||
              this.selectedMeasurementData.value_1 == null
            ) &&
              this.selectedMeasurementData.value_1 < 50) ||
            this.selectedMeasurementData.value_1 > 185
          ) {
            this.measurementErrors.push("Length must be between 50 and 185");
          }
          if (
            (!(
              this.selectedMeasurementData.value_2 == "" ||
              this.selectedMeasurementData.value_2 == null
            ) &&
              this.selectedMeasurementData.value_2 < 22) ||
            this.selectedMeasurementData.value_2 > 60
          ) {
            this.measurementErrors.push("Shoulder must be between 22 and  60");
          }
          if (
            (!(
              this.selectedMeasurementData.value_3 == "" ||
              this.selectedMeasurementData.value_3 == null
            ) &&
              this.selectedMeasurementData.value_3 < 30) ||
            this.selectedMeasurementData.value_3 > 94
          ) {
            this.measurementErrors.push("Waist must be between 30 and  94");
          }
          if (
            (!(
              this.selectedMeasurementData.value_4 == "" ||
              this.selectedMeasurementData.value_4 == null
            ) &&
              this.selectedMeasurementData.value_4 < 24) ||
            this.selectedMeasurementData.value_4 > 75
          ) {
            this.measurementErrors.push(
              "Sleeve's Length must be between 24 and  75"
            );
          }
          if (
            (!(
              this.selectedMeasurementData.value_5 == "" ||
              this.selectedMeasurementData.value_5 == null
            ) &&
              this.selectedMeasurementData.value_5 < 16) ||
            this.selectedMeasurementData.value_5 > 33
          ) {
            this.measurementErrors.push(
              "Cuff’s circumference must be between 16 and  33"
            );
          }
          if (
            (!(
              this.selectedMeasurementData.value_6 == "" ||
              this.selectedMeasurementData.value_6 == null
            ) &&
              this.selectedMeasurementData.value_6 < 8) ||
            this.selectedMeasurementData.value_6 > 23
          ) {
            this.measurementErrors.push(
              "Sleeve’s Width must be between 8 and 23"
            );
          }
          if (
            (!(
              this.selectedMeasurementData.value_7 == "" ||
              this.selectedMeasurementData.value_7 == null
            ) &&
              this.selectedMeasurementData.value_7 < 28) ||
            this.selectedMeasurementData.value_7 > 53
          ) {
            this.measurementErrors.push(
              "Thoob’s neck circumference must be between 28 and  53"
            );
          }
          if (
            (!(
              this.selectedMeasurementData.value_8 == "" ||
              this.selectedMeasurementData.value_8 == null
            ) &&
              this.selectedMeasurementData.value_8 < 35) ||
            this.selectedMeasurementData.value_8 > 95
          ) {
            this.measurementErrors.push(
              "Thoob’s Full chest must be between 30 and  95"
            );
          }
          if (
            (!(
              this.selectedMeasurementData.value_9 == "" ||
              this.selectedMeasurementData.value_9 == null
            ) &&
              this.selectedMeasurementData.value_9 < 40) ||
            this.selectedMeasurementData.value_9 > 95
          ) {
            this.measurementErrors.push(
              "Thoob’s F.chest must be between 40 and  95"
            );
          }
          if (
            (!(
              this.selectedMeasurementData.value_10 == "" ||
              this.selectedMeasurementData.value_10 == null
            ) &&
              this.selectedMeasurementData.value_10 < 36) ||
            this.selectedMeasurementData.value_10 > 100
          ) {
            this.measurementErrors.push(
              "Thoob’s hips must be between 36 and  100"
            );
          }
          if (
            (!(
              this.selectedMeasurementData.value_11 == "" ||
              this.selectedMeasurementData.value_11 == null
            ) &&
              this.selectedMeasurementData.value_11 < 10) ||
            this.selectedMeasurementData.value_11 > 36
          ) {
            this.measurementErrors.push(
              "Thoob’s armhole must be between 10 and  36"
            );
          }
          if (
            (!(
              this.selectedMeasurementData.value_12 == "" ||
              this.selectedMeasurementData.value_12 == null
            ) &&
              this.selectedMeasurementData.value_12 < 40) ||
            this.selectedMeasurementData.value_12 > 100
          ) {
            this.measurementErrors.push(
              "Thoob’s bottom length must be between 40 and  100"
            );
          }
        }
      }
    },
    searchPlace(placeId) {
      for (let i = 0; i < this.places.length; i++) {
        if (this.places[i].id == placeId) return this.places[i];
      }
      return null;
    },
    fetchAllPlaces() {
      this.formState.loading = true;
      return axios
        .post(`${herokuUrl}/dashboard/getAllplaces`, null, {
          headers: {
            Authorization: getCookie("user"),
          },
        })
        .then((res) => {
          this.places = res.data.places;
          this.dropDownPlaces = [{ value: null, text: "Please Select a city" }];
          this.places.forEach((place) => {
            if (place.country_id != null || place.country_id != null) {
              this.dropDownPlaces.push({ value: place.id, text: place.name });
            }
          });
          this.formState.loading = false;
        })
        .catch((err) => {
          if (err.response.status == 401) {
            logOut();
          } else {
            this.formState.loading = false;
            alert("Locations fetching failed, " + err.response.data.message);
          }
          // window.location.reload();
        });
    },
    fetchAllUsers() {
      this.formState.loading = true;
      console.log({
        ...this.searchCriteria,
        page: this.isSearching() ? this.searchPage : this.searchCriteria.page,
      });
      return axios
        .post(
          `${herokuUrl}/dashboard/getAllusers`,
          {
            // searchCriteria: {
            //   page: this.searchCriteria.page ? this.searchCriteria.page : null,
            //   email: this.searchCriteria.email
            //     ? this.searchCriteria.email
            //     : null,
            //   mobile: this.searchCriteria.mobile
            //     ? this.searchCriteria.mobile
            //     : null,
            //   placeId: this.searchCriteria.placeId
            //     ? this.searchCriteria.placeId
            //     : null
            // }
            searchCriteria: {
              ...this.searchCriteria,
              page: this.isSearching()
                ? this.searchPage
                : this.searchCriteria.page,
            },
          },
          {
            headers: {
              Authorization: getCookie("user"),
            },
          }
        )
        .then((res) => {
          console.log('====================================');
          console.log(res);
          console.log('====================================');
          this.fetchedUsers = res.data.users.allUsers;
          this.count = Math.ceil(res.data.users.count / 20);
          this.formState.loading = false;
        })
        .catch((err) => {
                    console.log('====================================');
          console.log(err);
          console.log('====================================');
          if (err.response.status == 401) {
            logOut();
          } else {
            this.formState.loading = false;
            alert("Users fetching failed, " + err.response.data.message);
          }
          // window.location.reload();
        });
    },
    fetchAllUserMeasurements(id) {
      this.formState.loading = true;
      return axios
        .post(
          `${herokuUrl}/dashboard/getallUserMeasurements`,
          { userId: id },
          {
            headers: {
              Authorization: getCookie("user"),
            },
          }
        )
        .then((res) => {
          this.selectedUserData.measurementData = res.data.measurementData;
          // https://www.freecodecamp.org/news/common-mistakes-to-avoid-while-working-with-vue-js-10e0b130925b/
          // DON'T REMOVE THE FOLLOWING LINE. Check the link above to know why this exists.
          this.selectedUserData = { ...this.selectedUserData };
          this.formState.loading = false;
        })
        .catch((err) => {
          if (err.response.status == 401) {
            logOut();
          } else {
            this.formState.loading = false;
            alert("users fetching failed, " + err.response.data.message);
          }
          // window.location.reload();
        });
    },
    // EDIT THIS
    fetchAllUserOrders(id) {
      this.formState.loading = true;
      return axios
        .post(
          `${herokuUrl}/dashboard/getAllOrders`,
          { userId: id, pageSize: 1000000, pageIndex: 1 },
          {
            headers: {
              Authorization: getCookie("user"),
            },
          }
        )
        .then((res) => {
          this.selectedUserData.orderData = res.data.orders;
          // https://www.freecodecamp.org/news/common-mistakes-to-avoid-while-working-with-vue-js-10e0b130925b/
          // DON'T REMOVE THE FOLLOWING LINE. Check the link above to know why this exists.
          this.selectedUserData = { ...this.selectedUserData };
          this.formState.loading = false;
        })
        .catch((err) => {
          if (err.response.status == 401) {
            logOut();
          } else {
            this.formState.loading = false;
            alert("users fetching failed, " + err.response.data.message);
          }
          // window.location.reload();
        });
    },
    deleteUser() {
      if (confirm("Please confirm you want to DELETE the selected user")) {
        this.formState.loading = true;
        return axios
          .post(
            `${herokuUrl}/dashboard/deleteUser`,
            {
              id: this.selectedUserData.id,
            },
            {
              headers: {
                Authorization: getCookie("user"),
              },
            }
          )
          .then(() => {
            alert("user was deleted successfully");
            this.partiallyResetForm();
            this.fetchAllUsers();
          })
          .catch((err) => {
            if (err.response.status == 401) {
              logOut();
            } else {
              this.formState.loading = false;
              alert(
                "There was a problem deleting the selected user " +
                  err.response.data.message
              );
            }
          });
      }
    },
    deleteMeasurement() {
      if (
        confirm("Please confirm you want to DELETE the selected measurement")
      ) {
        this.formState.loading = true;
        return axios
          .post(
            `${herokuUrl}/dashboard/deleteMeasurementProfile`,
            {
              id: this.selectedMeasurementData.id,
            },
            {
              headers: {
                Authorization: getCookie("user"),
              },
            }
          )
          .then(() => {
            alert("measurement was deleted successfully");
            // this.partiallyResetForm();
            this.fetchAllUserMeasurements(this.selectedUserId);
          })
          .catch((err) => {
            if (err.response.status == 401) {
              logOut();
            } else {
              this.formState.loading = false;
              alert(
                "There was a problem deleting the selected measurement " +
                  err.response.data.message
              );
            }
          });
      }
    },
    //EDIT This
    deleteOrder() {
      if (confirm("Please confirm you want to DELETE the selected order")) {
        this.formState.loading = true;
        return axios
          .post(
            `${herokuUrl}/dashboard/deleteOrder`,
            {
              id: this.selectedOrderData.id,
            },
            {
              headers: {
                Authorization: getCookie("user"),
              },
            }
          )
          .then(() => {
            alert("order was deleted successfully");
            // this.partiallyResetForm();
            this.fetchAllUserMeasurements(this.selectedUserId);
            this.fetchAllUserOrders(this.selectedUserId);
          })
          .catch((err) => {
            if (err.response.status == 401) {
              logOut();
            } else {
              this.formState.loading = false;
              alert(
                "There was a problem deleting the selected order " +
                  err.response.data.message
              );
            }
          });
      }
    },
    commitUserChanges() {
      this.formState.attempted = true;
      if (!this.errors.length) {
        if (
          confirm(
            "Please confirm you want to UPDATE the selected user with the new data"
          )
        ) {
          this.formState.loading = true;
          return axios
            .post(`${herokuUrl}/dashboard/editUser`, this.selectedUserData, {
              headers: {
                Authorization: getCookie("user"),
              },
            })
            .then(() => {
              alert("user was Edited successfully");
              this.partiallyResetForm();
            })
            .catch((err) => {
              if (err.response.status == 401) {
                logOut();
              } else {
                this.formState.loading = false;
                alert(
                  "There was a problem editing the selected user " +
                    err.response.data.message
                );
              }
            });
        }
      } else {
        this.shakeForm();
      }
    },
    commitMeasurementChanges() {
      this.formState.attempted = true;
      if (
        !this.measurementErrors.length
        // !(
        //   this.selectedMeasurementData.name == "" ||
        //   this.selectedMeasurementData.name == null
        // )
      ) {
        if (
          confirm(
            "Please confirm you want to UPDATE the selected measurement with the new data"
          )
        ) {
          this.formState.loading = true;
          return axios
            .post(
              `${herokuUrl}/dashboard/editMeasurementProfile`,
              this.selectedMeasurementData,
              {
                headers: {
                  Authorization: getCookie("user"),
                },
              }
            )
            .then(() => {
              alert("measurement was Edited successfully");
              // this.partiallyResetForm();
              this.fetchAllUserMeasurements(this.selectedUserId);
            })
            .catch((err) => {
              if (err.response.status == 401) {
                logOut();
              } else {
                this.formState.loading = false;
                alert(
                  "There was a problem editing the selected measurement " +
                    err.response.data.message
                );
              }
            });
        }
      } else {
        this.shakeForm();
      }
    },
    changeOrderStatus() {
      this.formState.attempted = true;
      // Replace true with conditions
      // eslint-disable-next-line
      if (true) {
        if (
          confirm(
            "Please confirm you want to update the selected Order's status"
          )
        ) {
          {
            this.formState.loading = true;
            return axios
              .put(
                `${herokuUrl}/dashboard/update-order-status`,
                {
                  orderId: this.selectedOrderData.id,
                  orderStatus: this.selectedOrderData.status,
                },
                {
                  headers: {
                    Authorization: getCookie("user"),
                  },
                }
              )
              .then((res) => {
                if (res.data.status) {
                  alert("Order was Edited successfully");
                  // this.partiallyResetForm();
                  this.fetchAllUserOrders(this.selectedUserId);
                } else {
                  alert(
                    "There was a problem editing the selected Order " +
                      res.data.message
                  );
                }
              })
              .catch((err) => {
                if (err.response.status == 401) {
                  logOut();
                } else {
                  this.formState.loading = false;
                  alert(
                    "There was a problem editing the selected Order " +
                      err.response.data.message
                  );
                }
              });
          }
        }
      } else {
        this.shakeForm();
      }
    },
    changeOrderDeliveryType() {
      this.formState.attempted = true;
      // Replace true with conditions
      // eslint-disable-next-line
      if (true) {
        if (
          confirm(
            "Please confirm you want to update the selected order's delivery type"
          )
        ) {
          {
            this.formState.loading = true;
            return axios
              .put(
                `${herokuUrl}/dashboard/change-order-delivery`,
                {
                  orderId: this.selectedOrderData.id,
                  deliveryMethod: this.selectedOrderData.delivery_type,
                },
                {
                  headers: {
                    Authorization: getCookie("user"),
                  },
                }
              )
              .then(() => {
                alert("Order was Edited successfully");
                // this.partiallyResetForm();
                this.fetchAllUserOrders(this.selectedUserId);
              })
              .catch((err) => {
                if (err.response.status == 401) {
                  logOut();
                } else {
                  this.formState.loading = false;
                  alert(
                    "There was a problem editing the selected Order " +
                      err.response.data.message
                  );
                }
              });
          }
        }
      } else {
        this.shakeForm();
      }
    },
    shakeForm() {
      this.formState.invalidShake = true;
      setTimeout(
        function () {
          this.formState.invalidShake = false;
        }.bind(this),
        820
      );
    },
  },
  components: {
    appNavigation: Navigation,
  },
};
</script>
